<div class="grid lg:grid-cols-2 gap-y-10 gap-x-10 md:gap-y-0">
  <div class="flex flex-col gap-y-10">
    <!-- Customer and Establishment information -->
    <app-card heading="Pagador e Recebedor">
      <div
        class="grid justify-center items-center gap-2.5 lg:grid-cols-[1fr_auto_1fr] lg:gap-0 lg:gap-x-2.5 lg:justify-between">
        <app-party-summary [name]="customerName()" [document]="getPartyDocument(customerDocument())"
          [isLoading]="isLoading()" />
        <app-icon-frame class="text-primary/50 mx-auto">
          <app-icon icon="arrow-right-left" [size]="18" />
        </app-icon-frame>
        <app-party-summary
          class="lg:justify-self-end"
          [name]="receiverName()"
          [document]="getPartyDocument(receiverDocument())"
          [source]="receiverAvatarUrl()"
          [isLoading]="isLoading()"
        />
      </div>
    </app-card>

    <!-- Transaction Summary -->
    <div class="flex flex-col gap-y-5">
      <app-card heading="Resumo da Transação" [contentNoPadding]="true">
        <app-table [columns]="columns" [data]="products()" />
      </app-card>
      <div class="flex gap-x-5 items-center justify-end bg-gray-50 rounded-md px-2.5 py-3">
        <span class="text-sm text-gray-900 font-medium leading-tight">Total</span>
        <span class="text-sm text-black font-semibold leading-tight">{{ total() }}</span>
      </div>
    </div>
  </div>
  <div class="flex flex-col gap-y-10">
    <!-- Payment Methods -->
    <app-card heading="Forma de Pagamento">
      <form class="flex flex-col items-end gap-y-8" [formGroup]="paymentMethodForm()" (ngSubmit)="onSubmit()()">
        <app-radio-group #radioGroup class="w-full grid xl:grid-cols-3 gap-4" formControlName="method" [disabled]="isSubmitting()">
          @if (isLoading()) {
          <div class="kt-skeleton w-full h-[88px] rounded-xl"></div>
          <div class="kt-skeleton w-full h-[88px] rounded-xl"></div>
          <div class="kt-skeleton w-full h-[88px] rounded-xl"></div>
          } @else {
            @for (method of paymentMethods(); track method.value) {
              <app-fancy-radio-button
                [id]="method.value"
                name="method"
                [disabled]="isSubmitting()"
                [label]="method.label"
                [value]="method.value"
                [icon]="method.icon"
                [selected]="radioGroup.value() === method.value"
                (clicked)="radioGroup.select($event)"
              />
            }
          }
        </app-radio-group>
        @if (hasPaymentMethod() && !isCreditCard()) {
          <button type="submit" class="kt-btn flex items-center w-full lg:w-auto" [disabled]="isSubmitting() || threeDSBlocking()">
            <span class="leading-tight font-medium">
              Continuar
            </span>
            <app-icon icon="right" [size]="12" />
          </button>
        }
      </form>
    </app-card>

    <!-- Credit Card Form -->
    @if (isCreditCard()) {
    <app-card heading="Cartão de Crédito">
      <form class="grid md:grid-cols-2 gap-5" [formGroup]="creditCardForm()" (ngSubmit)="onSubmit()()">
        <app-input formControlName="cardHolder" class="col-span-full" label="Nome impresso no cartão"
          placeholder="Nome impresso no cartão" icon="user" />
        <app-input formControlName="cardNumber" class="col-span-full" label="Número do cartão"
          placeholder="Número do cartão" icon="credit-card" [mask]="cardMask" />
        <app-input formControlName="validThru" label="Data de validade" placeholder="MM/AA" icon="calendar"
          [mask]="validThruMask" />
        <app-input formControlName="cvv" label="Código de segurança (CVV)" placeholder="CVV" icon="lock-2"
          [mask]="cvvMask" />
        <app-select
            formControlName="installments"
            label="Parcelamento"
            placeholder="Quantidade de parcelas"
            [options]="installmentOptions()"
          />
        <div class="flex justify-end items-center col-span-full">
          <button type="submit" class="kt-btn flex items-center w-full lg:w-auto" [disabled]="isSubmitting() || threeDSBlocking()">
            <span class="leading-tight font-medium">
              Continuar
            </span>
            <app-icon icon="right" [size]="12" />
          </button>
        </div>
      </form>
    </app-card>
    }
  </div>
</div>
